<template>
    <v-main>
        <v-container>
        <head>
            <title>{{trial.name}} - Foraje</title>
            <meta name="description" :content="'Trial' + trial.name + ' Details -- ' + trial.description">
        </head>
            <v-card>
                <v-card-title>
                    <h2>{{trial.name}}</h2>
                    <v-spacer></v-spacer>
                    <v-text-field
                            v-model="searchvalue"
                            append-icon="search"
                            label="Search"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                        :headers="trialheaders"
                        :items="measurements"
                        class="elevation-1"
                        :loading="aretrialsloading"
                        :search="searchvalue"
                        :pagination.sync="tablepagination"
                        :rows-per-page-items="rowsperpageitems"
                >
                    <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                    <template slot="no-data">
                        <v-alert :value="!aretrialsloading" color="secondary">
                            Sorry, you have no measurements to show here. If you have some we don't know about, Go ahead and create one now!.
                        </v-alert>
                    </template>

                    <template slot="items" slot-scope="props">

                        <td v-if="props.item.name"><router-link :to="'/crops/' ">{{ props.item.name }}</router-link></td>
                        <td v-else>No Name</td>

                        <td v-if="props.item.quantitative_component_measurement.length">{{ props.item.quantitative_component_measurement[0].raw_user_submission }}</td>
                        <td v-else-if="props.item.qualitative_component_measurement.length">{{props.item.qualitative_component_measurement[0].qualitative_value.substring(0,50)}}</td>
                        <td v-else>N/A</td>

                        <td v-if="props.item.quantitative_component_measurement.length">{{ props.item.quantitative_component_measurement[0].units }}</td>
                        <td v-else>N/A</td>

                        <td v-if="props.item.quantitative_component_measurement.length">{{ props.item.quantitative_component_measurement[0].type }}</td>
                        <td v-else-if="props.item.qualitative_component_measurement.length">{{props.item.qualitative_component_measurement[0].type}}</td>
                        <td v-else>N/A</td>

                        <td v-if="props.item.date_time">{{ new Date(props.item.date_time)}}</td>
                        <td v-else>Measurement Date Unknown</td>

                        <td class="justify-center layout px-0">
                            <v-icon
                                    small
                                    class="mr-2"
                                    @click="EditMeasurementDialog(props.item)"
                            >
                                edit
                            </v-icon>
                            <v-icon
                                    small
                                    @click="DeleteMeasurementDialog(props.item)"
                            >
                                delete
                            </v-icon>
                        </td>

                        <td>
                            <router-link :to="'/forms/products/edit/' + props.item.slug" class="-li">
                                <v-icon
                                        small
                                        class="mr-2"
                                >
                                    exit_to_app
                                </v-icon>
                            </router-link>
                        </td>
                        <td>
                            <v-icon
                                    small
                                    @click="DuplicateMeasurementDialog(props.item)"
                            >
                                file_copy
                            </v-icon>
                        </td>

                    </template>
                </v-data-table>
            </v-card>
        </v-container>
    </v-main>
</template>

<script>
import axios from 'axios';

export default {
  name: 'TrialDetails',
  data: () => ({
    aretrialsloading: false,

    trial: [],
    measurements: [],

    rowsperpageitems: [5, 10, 25, { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }],
    tablepagination: {
      rowsPerPage: 25,
    },
    trialheaders: [
      {
        text: 'Name',
        align: 'left',
        sortable: true,
        value: 'name',
      },
      { text: 'Value', value: 'value', sortable: true },
      { text: 'Units', value: 'units', sortable: true },
      { text: 'Type', value: 'type', sortable: true },
      { text: 'Measurement Date/Time', value: 'date_time', sortable: true },
      { text: 'Quick Edit/Delete', value: 'edit_delete', sortable: false },
      { text: 'Full Edit', value: 'complete_edit', sortable: false },
      { text: 'Duplicate', value: 'duplicate', sortable: false },
    ],
  }),

  methods: {
    GetTrialDetails() {
      this.aretrialsloading = true;
      const authheader = `Token ${this.$store.getters.token}`;
      return axios.get(`measurements/trial/details/${this.$route.params.slug}`,

        {
          headers: {
            Authorization: authheader,
          },
        })
        .then((response) => {
          this.trial = response.data;
          this.measurements = response.data.component_measurement;
        })
        .then(() => {
          this.aretrialsloading = false;
          console.log(this.measurements);
        });
    },
  },
  created() {
    this.GetTrialDetails();
  },
};
</script>

<style scoped>

</style>
